import React, { useEffect, useState } from "react";
import EventsImage from "../assets/events.png";
import Newsletter from "./newsLetter";
import { Link } from "react-router-dom";
import { format } from "date-fns";

const Events = () => {
  const [eventData, setEventData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEventData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/events?populate=*`,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
            },
          }
        );
        const data = await response.json();

        if (data?.data && data.data.length > 0) {
          const sortedEvents = data.data.sort(
            (a, b) => new Date(b.attributes.date) - new Date(a.attributes.date)
          );
          setEventData(sortedEvents);
        } else {
          setEventData([]);
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching event data: ", error);
        setLoading(false);
      }
    };

    fetchEventData();
  }, []);

  return (
    <>
      <div className="relative w-full h-[440px]">
        {/* Background Image */}
        <img
          src={EventsImage}
          alt="Events Background"
          className="absolute inset-0 w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black opacity-70"></div>

        <div className="absolute inset-0 flex flex-col justify-center items-center px-4 text-center">
          <h1 className="text-[40px] md:text-[64px] font-primary font-bold leading-tight text-white">
            Events
          </h1>

          <p className="mt-4 text-[16px] md:text-[18px] font-primary font-normal leading-relaxed text-white max-w-[577px]">
            Meet the diverse organizations that support and strengthen our
            mission for social justice and community empowerment.
          </p>
        </div>
      </div>

      {loading && (
        <div className="flex col-span-full mt-12 h-[80vh] justify-center items-center text-custom-blue">
          <svg
            className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-custom-orange rounded-full"
            viewBox="0 0 24 24"
          ></svg>
          Loading events...
        </div>
      )}

      <div
        className={`max-w-full xl:w-[1200px] h-auto pt-[50px] px-4 md:px-[120px] pb-[50px] gap-[64px] mx-auto transition-opacity duration-700 ${
          !loading ? "opacity-100" : "opacity-0"
        }`}
      >
        {eventData.map((event, index) => {
          const { title, content, date, content_image, location } =
            event.attributes;
          const imageUrl =
            content_image?.data?.[0]?.attributes?.formats?.medium?.url || "";

          const formattedDate = format(
            new Date(`${date}T00:00:00`),
            "eee MMM dd yyyy"
          );
          const cleanContent = (content) => {
            if (!content) {
              return "";
            }

            // Remove lines starting with #
            let lines = content
              .split("\n")
              .filter((line) => !line.trim().startsWith("#"));

            // Join lines back into a string
            let cleanedContent = lines.join(" ");

            // Remove text enclosed in **
            cleanedContent = cleanedContent.replace(/\*\*(.*?)\*\*/g, "");

            // Trim any extra whitespace
            cleanedContent = cleanedContent.trim();

            return cleanedContent;
          };

          const cleanedContent = cleanContent(content);

          const truncatedContent = cleanedContent
            ? cleanedContent.length > 118
              ? cleanedContent.substring(0, 118) + "..."
              : cleanedContent
            : "Event content description goes here.";

          return (
            <div
              key={index}
              className="flex flex-col md:flex-row mb-[50px] items-start"
            >
              {/* First div for image */}
              <div className="w-full md:w-[414px] h-[250px] md:h-[338px] border border-gray-300 rounded-[20px] overflow-hidden">
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt={title}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full bg-gray-300 flex items-center justify-center">
                    No Image
                  </div>
                )}
              </div>

              {/* Second div for event details */}
              <div className="w-full md:w-[477px] h-auto mt-4 md:mt-0 md:ml-8">
                {/* First div for title */}
                <div className="mb-[16px]">
                  <h1 className="text-[24px] md:text-[32px] font-primary font-semibold leading-tight text-[#002A57] break-words">
                    {title || "Event Title"}
                  </h1>
                </div>

                {/* Second div for content */}
                <div className="mb-[16px]">
                  <p className="text-[16px] md:text-[18px] font-secondary font-normal leading-relaxed text-[#433E3F]">
                    {truncatedContent || "Description."}
                  </p>
                </div>
                {/* Third div for date */}
                <div className="h-[36px] mb-[16px]  flex items-center gap-4">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M28.5 4H26V3C26 2.46957 25.7893 1.96086 25.4142 1.58579C25.0391 1.21071 24.5304 1 24 1C23.4696 1 22.9609 1.21071 22.5858 1.58579C22.2107 1.96086 22 2.46957 22 3V4H18V3C18 2.46957 17.7893 1.96086 17.4142 1.58579C17.0391 1.21071 16.5304 1 16 1C15.4696 1 14.9609 1.21071 14.5858 1.58579C14.2107 1.96086 14 2.46957 14 3V4H10V3C10 2.46957 9.78929 1.96086 9.41421 1.58579C9.03914 1.21071 8.53043 1 8 1C7.46957 1 6.96086 1.21071 6.58579 1.58579C6.21071 1.96086 6 2.46957 6 3V4H3.5C2.83696 4 2.20107 4.26339 1.73223 4.73223C1.26339 5.20107 1 5.83696 1 6.5V26.5C1 27.163 1.26339 27.7989 1.73223 28.2678C2.20107 28.7366 2.83696 29 3.5 29H17.5C17.6326 29 17.7598 28.9473 17.8536 28.8536C17.9473 28.7598 18 28.6326 18 28.5C18 28.3674 17.9473 28.2402 17.8536 28.1464C17.7598 28.0527 17.6326 28 17.5 28H3.5C3.10254 27.9988 2.7217 27.8404 2.44065 27.5593C2.1596 27.2783 2.00119 26.8975 2 26.5V11H30V19.5C30 19.6326 30.0527 19.7598 30.1464 19.8536C30.2402 19.9473 30.3674 20 30.5 20C30.6326 20 30.7598 19.9473 30.8536 19.8536C30.9473 19.7598 31 19.6326 31 19.5V6.5C31 5.83696 30.7366 5.20107 30.2678 4.73223C29.7989 4.26339 29.163 4 28.5 4ZM23 3C23 2.73478 23.1054 2.48043 23.2929 2.29289C23.4804 2.10536 23.7348 2 24 2C24.2652 2 24.5196 2.10536 24.7071 2.29289C24.8946 2.48043 25 2.73478 25 3V6C25 6.26522 24.8946 6.51957 24.7071 6.70711C24.5196 6.89464 24.2652 7 24 7C23.7348 7 23.4804 6.89464 23.2929 6.70711C23.1054 6.51957 23 6.26522 23 6V3ZM15 3C15 2.73478 15.1054 2.48043 15.2929 2.29289C15.4804 2.10536 15.7348 2 16 2C16.2652 2 16.5196 2.10536 16.7071 2.29289C16.8946 2.48043 17 2.73478 17 3V6C17 6.26522 16.8946 6.51957 16.7071 6.70711C16.5196 6.89464 16.2652 7 16 7C15.7348 7 15.4804 6.89464 15.2929 6.70711C15.1054 6.51957 15 6.26522 15 6V3ZM7 3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2C8.26522 2 8.51957 2.10536 8.70711 2.29289C8.89464 2.48043 9 2.73478 9 3V6C9 6.26522 8.89464 6.51957 8.70711 6.70711C8.51957 6.89464 8.26522 7 8 7C7.73478 7 7.48043 6.89464 7.29289 6.70711C7.10536 6.51957 7 6.26522 7 6V3ZM30 10H2V6.5C2.00119 6.10254 2.1596 5.7217 2.44065 5.44065C2.7217 5.1596 3.10254 5.00119 3.5 5H6V6C6 6.53043 6.21071 7.03914 6.58579 7.41421C6.96086 7.78929 7.46957 8 8 8C8.53043 8 9.03914 7.78929 9.41421 7.41421C9.78929 7.03914 10 6.53043 10 6V5H14V6C14 6.53043 14.2107 7.03914 14.5858 7.41421C14.9609 7.78929 15.4696 8 16 8C16.5304 8 17.0391 7.78929 17.4142 7.41421C17.7893 7.03914 18 6.53043 18 6V5H22V6C22 6.53043 22.2107 7.03914 22.5858 7.41421C22.9609 7.78929 23.4696 8 24 8C24.5304 8 25.0391 7.78929 25.4142 7.41421C25.7893 7.03914 26 6.53043 26 6V5H28.5C28.8975 5.00119 29.2783 5.1596 29.5593 5.44065C29.8404 5.7217 29.9988 6.10254 30 6.5V10Z"
                      fill="#FFA500"
                    />
                    <path
                      d="M15 14.5C15 14.2348 14.8946 13.9804 14.7071 13.7929C14.5196 13.6054 14.2652 13.5 14 13.5H12C11.7348 13.5 11.4804 13.6054 11.2929 13.7929C11.1054 13.9804 11 14.2348 11 14.5V16C11 16.2652 11.1054 16.5196 11.2929 16.7071C11.4804 16.8946 11.7348 17 12 17H14C14.2652 17 14.5196 16.8946 14.7071 16.7071C14.8946 16.5196 15 16.2652 15 16V14.5ZM12 16V14.5H14V16H12Z"
                      fill="#FFA500"
                    />
                    <path
                      d="M9 14.5C9 14.2348 8.89464 13.9804 8.70711 13.7929C8.51957 13.6054 8.26522 13.5 8 13.5H6C5.73478 13.5 5.48043 13.6054 5.29289 13.7929C5.10536 13.9804 5 14.2348 5 14.5V16C5 16.2652 5.10536 16.5196 5.29289 16.7071C5.48043 16.8946 5.73478 17 6 17H8C8.26522 17 8.51957 16.8946 8.70711 16.7071C8.89464 16.5196 9 16.2652 9 16V14.5ZM6 16V14.5H8V16H6Z"
                      fill="#FFA500"
                    />
                    <path
                      d="M26 17C26.2652 17 26.5196 16.8946 26.7071 16.7071C26.8946 16.5196 27 16.2652 27 16V14.5C27 14.2348 26.8946 13.9804 26.7071 13.7929C26.5196 13.6054 26.2652 13.5 26 13.5H24C23.7348 13.5 23.4804 13.6054 23.2929 13.7929C23.1054 13.9804 23 14.2348 23 14.5V16C23 16.2652 23.1054 16.5196 23.2929 16.7071C23.4804 16.8946 23.7348 17 24 17H26ZM24 14.5H26V16H24V14.5Z"
                      fill="#FFA500"
                    />
                    <path
                      d="M15 19C15 18.7348 14.8946 18.4804 14.7071 18.2929C14.5196 18.1054 14.2652 18 14 18H12C11.7348 18 11.4804 18.1054 11.2929 18.2929C11.1054 18.4804 11 18.7348 11 19V20.5C11 20.7652 11.1054 21.0196 11.2929 21.2071C11.4804 21.3946 11.7348 21.5 12 21.5H14C14.2652 21.5 14.5196 21.3946 14.7071 21.2071C14.8946 21.0196 15 20.7652 15 20.5V19ZM12 20.5V19H14V20.5H12Z"
                      fill="#FFA500"
                    />
                    <path
                      d="M9 19C9 18.7348 8.89464 18.4804 8.70711 18.2929C8.51957 18.1054 8.26522 18 8 18H6C5.73478 18 5.48043 18.1054 5.29289 18.2929C5.10536 18.4804 5 18.7348 5 19V20.5C5 20.7652 5.10536 21.0196 5.29289 21.2071C5.48043 21.3946 5.73478 21.5 6 21.5H8C8.26522 21.5 8.51957 21.3946 8.70711 21.2071C8.89464 21.0196 9 20.7652 9 20.5V19ZM6 20.5V19H8V20.5H6Z"
                      fill="#FFA500"
                    />
                    <path
                      d="M14 22.5H12C11.7348 22.5 11.4804 22.6054 11.2929 22.7929C11.1054 22.9804 11 23.2348 11 23.5V25C11 25.2652 11.1054 25.5196 11.2929 25.7071C11.4804 25.8946 11.7348 26 12 26H14C14.2652 26 14.5196 25.8946 14.7071 25.7071C14.8946 25.5196 15 25.2652 15 25V23.5C15 23.2348 14.8946 22.9804 14.7071 22.7929C14.5196 22.6054 14.2652 22.5 14 22.5ZM12 25V23.5H14V25H12Z"
                      fill="#FFA500"
                    />
                    <path
                      d="M18 17H20C20.2652 17 20.5196 16.8946 20.7071 16.7071C20.8946 16.5196 21 16.2652 21 16V14.5C21 14.2348 20.8946 13.9804 20.7071 13.7929C20.5196 13.6054 20.2652 13.5 20 13.5H18C17.7348 13.5 17.4804 13.6054 17.2929 13.7929C17.1054 13.9804 17 14.2348 17 14.5V16C17 16.2652 17.1054 16.5196 17.2929 16.7071C17.4804 16.8946 17.7348 17 18 17ZM18 14.5H20V16H18V14.5Z"
                      fill="#FFA500"
                    />
                    <path
                      d="M17 20.5C17 20.7652 17.1054 21.0196 17.2929 21.2071C17.4804 21.3946 17.7348 21.5 18 21.5C18.1326 21.5 18.2598 21.4473 18.3536 21.3536C18.4473 21.2598 18.5 21.1326 18.5 21C18.5 20.8674 18.4473 20.7402 18.3536 20.6464C18.2598 20.5527 18.1326 20.5 18 20.5V19H20C20.1326 19 20.2598 18.9473 20.3536 18.8536C20.4473 18.7598 20.5 18.6326 20.5 18.5C20.5 18.3674 20.4473 18.2402 20.3536 18.1464C20.2598 18.0527 20.1326 18 20 18H18C17.7348 18 17.4804 18.1054 17.2929 18.2929C17.1054 18.4804 17 18.7348 17 19V20.5Z"
                      fill="#FFA500"
                    />
                    <path
                      d="M8 22.5H6C5.73478 22.5 5.48043 22.6054 5.29289 22.7929C5.10536 22.9804 5 23.2348 5 23.5V25C5 25.2652 5.10536 25.5196 5.29289 25.7071C5.48043 25.8946 5.73478 26 6 26H8C8.26522 26 8.51957 25.8946 8.70711 25.7071C8.89464 25.5196 9 25.2652 9 25V23.5C9 23.2348 8.89464 22.9804 8.70711 22.7929C8.51957 22.6054 8.26522 22.5 8 22.5ZM6 25V23.5H8V25H6Z"
                      fill="#FFA500"
                    />
                    <path
                      d="M24.5 18C23.2144 18 21.9577 18.3812 20.8888 19.0954C19.8199 19.8097 18.9868 20.8248 18.4948 22.0126C18.0028 23.2003 17.8741 24.5072 18.1249 25.7681C18.3757 27.029 18.9948 28.1872 19.9038 29.0962C20.8129 30.0052 21.971 30.6243 23.2319 30.8751C24.4928 31.1259 25.7997 30.9972 26.9874 30.5052C28.1752 30.0132 29.1903 29.1801 29.9046 28.1112C30.6188 27.0423 31 25.7856 31 24.5C30.998 22.7767 30.3126 21.1246 29.094 19.906C27.8754 18.6874 26.2233 18.002 24.5 18ZM24.5 30C23.4122 30 22.3488 29.6774 21.4444 29.0731C20.5399 28.4687 19.8349 27.6098 19.4187 26.6048C19.0024 25.5998 18.8935 24.4939 19.1057 23.427C19.3179 22.3601 19.8417 21.3801 20.6109 20.6109C21.3801 19.8417 22.3601 19.3179 23.427 19.1057C24.4939 18.8935 25.5998 19.0024 26.6048 19.4187C27.6098 19.8349 28.4687 20.5399 29.0731 21.4444C29.6774 22.3488 30 23.4122 30 24.5C29.9983 25.9582 29.4183 27.3561 28.3872 28.3872C27.3561 29.4183 25.9582 29.9983 24.5 30Z"
                      fill="#FFA500"
                    />
                    <path
                      d="M27.3896 22.4031L23.5006 26.2921L21.7331 24.5241C21.6388 24.433 21.5125 24.3826 21.3814 24.3837C21.2503 24.3849 21.1249 24.4374 21.0322 24.5301C20.9395 24.6228 20.8869 24.7483 20.8858 24.8794C20.8846 25.0104 20.935 25.1368 21.0261 25.2311L23.1471 27.3526C23.2409 27.4463 23.368 27.4989 23.5006 27.4989C23.6332 27.4989 23.7603 27.4463 23.8541 27.3526L28.0966 23.1101C28.1877 23.0158 28.2381 22.8895 28.2369 22.7584C28.2358 22.6273 28.1832 22.5018 28.0905 22.4091C27.9978 22.3164 27.8724 22.2639 27.7413 22.2627C27.6102 22.2616 27.4839 22.312 27.3896 22.4031Z"
                      fill="#FFA500"
                    />
                  </svg>

                  <p className="text-[14px] md:text-[16px] font-primary font-medium leading-[28.8px] text-[#433E3F]">
                    {formattedDate}
                  </p>
                </div>

                <div className="flex items-center mb-[24px] gap-4 ">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.0021 6.3916C13.4523 6.3916 11.3779 8.46598 11.3779 11.0158C11.3779 13.5656 13.4523 15.64 16.0021 15.64C18.5518 15.64 20.6262 13.5656 20.6262 11.0158C20.6262 8.46598 18.5517 6.3916 16.0021 6.3916ZM16.0021 14.3651C14.1552 14.3651 12.6528 12.8627 12.6528 11.0158C12.6528 9.16891 14.1552 7.66648 16.0021 7.66648C17.8489 7.66648 19.3513 9.16898 19.3513 11.0158C19.3513 12.8626 17.8489 14.3651 16.0021 14.3651Z"
                      fill="#FFA500"
                    />
                    <path
                      d="M16.0011 0C9.92644 0 4.98444 4.942 4.98438 11.0166C4.98438 14.1991 6.76294 18.6666 10.2704 24.2949C12.8553 28.4426 15.4772 31.7282 15.5034 31.7609C15.6244 31.912 15.8075 32 16.0011 32C16.1946 32 16.3777 31.9121 16.4986 31.7609C16.5247 31.7282 19.1468 28.4426 21.7316 24.2949C25.2391 18.6665 27.0176 14.1991 27.0176 11.0166C27.0176 4.942 22.0756 0 16.0011 0ZM16.0011 30.3235C13.9491 27.6412 6.25938 17.1771 6.25938 11.0166C6.25938 5.645 10.6295 1.27494 16.0011 1.27494C21.3726 1.27494 25.7428 5.645 25.7428 11.0166C25.7428 17.1771 18.0531 27.6412 16.0011 30.3235Z"
                      fill="#FFA500"
                    />
                    <path
                      d="M23.1826 5.66039C22.0596 4.15645 20.4593 3.0212 18.6765 2.46383C18.3401 2.35864 17.9829 2.54608 17.8778 2.88208C17.7728 3.21808 17.9601 3.57564 18.2961 3.6807C21.5188 4.6882 23.6841 7.63601 23.6841 11.0159C23.6841 11.368 23.9696 11.6533 24.3216 11.6533C24.6736 11.6533 24.959 11.368 24.9589 11.0159C24.9589 9.06845 24.3447 7.21651 23.1826 5.66039Z"
                      fill="#FFA500"
                    />
                    <path
                      d="M16.5482 2.07412C16.3668 2.06318 16.1823 2.05762 15.9997 2.05762C15.6477 2.05762 15.3623 2.34299 15.3623 2.69505C15.3623 3.04712 15.6477 3.33249 15.9997 3.33249C16.1567 3.33249 16.3154 3.33724 16.4712 3.34668C16.4843 3.34749 16.4973 3.34787 16.5103 3.34787C16.8447 3.34787 17.1254 3.08724 17.1459 2.74887C17.1672 2.39749 16.8996 2.09543 16.5482 2.07412Z"
                      fill="#FFA500"
                    />
                  </svg>

                  <p className="text-[18px]  font-secondary font-normal leading-[30.94px] text-[#433E3F]">
                    {location || "Event location."}
                  </p>
                </div>

                {/* Fourth div for View More button */}
                <div className="h-[48px] flex items-start">
                  <Link to={`/events/${event.id}`}>
                    <button className="w-full md:w-[152px] h-[48px] bg-[#002A57] rounded-[30px] text-white flex items-center justify-center">
                      <span className="text-[13px] font-primary font-medium leading-[18px]">
                        View More
                      </span>
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <Newsletter />
    </>
  );
};

export default Events;
